import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';

import Farms from '@/views/farms/Farms';
import FarmMap from '@/views/farms/FarmMap';
import FarmList from '@/views/farms/FarmList';
import FarmDashboard from '@/views/farms/dash/FarmDashboard';
// import List from '@/views/crops/List';

export default {
  path: 'farms',
  component: Farms,
  name: 'farms',
  meta: { title: 'My Farms' },
  beforeEnter: multiguard([ middleware.hasPlan, middleware.isNotSuperImpact ]),
  children: [
    {
      path: 'map-view',
      component: FarmMap,
      name: 'map-view',
      meta: { title: 'Map View' },
      props: { satellite: false, fieldId : null },
      children: [
        // {
        //   path: 'field/:fieldId',
        //   component: FarmMap,
        //   name: 'field-info',
        //   meta: {title: 'Field info'},
        //   children: [
        //     {
        //       path: 'satellite',
        //       components: FarmMap,
        //       name: 'field-satellite-view',
        //       meta: 'Satellite view'
        //     }
        //   ]
        // },
      ]
    },
    {
      path: 'list-view',
      component: FarmList,
      name: 'list-view',
      meta: { title: 'List View' },
      children: [
        {
          path: ':farmId/:fieldId?',
          component: FarmDashboard,
          name: 'farm-dashboard',
          meta: { title: 'Farm Dashboard' },
          // children: [
          //   {
          //     path: '',
          //     component: FarmDashboard,
          //     name : 'field-dashboard',
          //     meta: { title: 'Field Dashboard' },
          //   },
          // ]
        },
      ]
    },
    // {
    //   path: 'satellite/:fieldId',
    //   component: FarmMap,
    //   name: 'satellite-view-map',
    //   meta: { title: 'Map View' },
    // }
  ]
};
